export const PAYMENT_TYPES_NAME = {
    PAYPAL: 'paypal_vault',
    CREDIT_CARD: 'paysafecard',
    APPLE_PAY: 'apple_pay',
    GOOGLE_PAY: 'google_pay',
};

export const analyticSystemNumberMapper: Record<string, number> = {
    [PAYMENT_TYPES_NAME.PAYPAL]: 4,
    [PAYMENT_TYPES_NAME.CREDIT_CARD]: 1,
    [PAYMENT_TYPES_NAME.APPLE_PAY]: 3,
    [PAYMENT_TYPES_NAME.GOOGLE_PAY]: 2,
};
